// Module
var code = `<div class="col-lg-12">
    <bfg-chart name="runner_battler.RbRetentionByMissionChart"></bfg-chart>
</div>

<installs-table
    prec="3"
    rows="rows"
>
</installs-table>
`;
// Exports
module.exports = code;